<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getResourceCenterTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionResourceCenter && permissionResourceCenter.permission_id === permission.readWrite"
          @click.native="clearResourceCenterData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in dataTable" :key="item.id">
            <td width="5" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{item.branch ? item.branch.branch_name_en : ''}}</td>
            <td>{{item.title_th}}</td>
            <td>{{item.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showResourceCenterData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import CircleButton from "../../components/Button/CircleButton";
    import InputSearch from "../../components/Input/InputSearch";
    import IconPencil from "../../components/Icon/icon-pencil";
    import {mapState} from "vuex";
    import Paginate from "../../components/Layout/Paginate";
    import {permissionResourceCenter, role} from "../../util/Permission";
    import Swal from 'sweetalert';
    import Loading from 'vue-loading-overlay';

    export default {
        name: "ResourceCenterTable",
      components: {Paginate, IconPencil, InputSearch, CircleButton, Loading},
      data(){
          return{
            title : 'Resource center',
            isLoading : false,
            headers: [
              { id: 1, text: "No." },
              { id: 2, text: "Branch" },
              { id: 3, text: "Topic" },
              { id: 4, text: "Update date" },
              { id: 5, text: "Edit" }
            ],
            dataTable :[],
            dataPaginate: {
              current_page: 1,
              from: 1,
              last_page: 1,
              per_page: 1,
              total: 1,
              to: 1
            },
            permission : null,
            search : '',
          }
        },

      created() {
          this.permission = role;
          this.getResourceCenterTable(1);
      },
      computed: {
        permissionResourceCenter,
        ...mapState({
          form: state => {
            return state.ResourceCenter.form;
          }
        })
      },
      methods:{
          getResourceCenterTable(page){
            this.isLoading = true;
            this.$store.dispatch("ResourceCenter/getResourceCenter",{
              page,
              search : this.search
            }).then(res=>{
              if(res.response_code == 200){
                this.dataTable = res.result.data;
                this.dataPaginate = {
                  current_page: res.result.current_page,
                  from: res.result.from,
                  last_page: res.result.last_page,
                  per_page: res.result.per_page,
                  total: res.result.total,
                  to: res.result.to
                }
              }
              this.isLoading = false;
            }).catch(()=>{
              Swal('','Cannot request Resource center data','error');
              this.isLoading = false;
            })
          },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getResourceCenterTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToResourceCenterEdit(){
            this.$router.push("/resource-center/edit");
        },
        showResourceCenterData(id){
          this.isLoading = true;
          this.$store.dispatch("ResourceCenter/showResourceCenter",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("ResourceCenter/setFormResourceCenter",res.result).then(()=>{
                this.goToResourceCenterEdit();
              })
            }
            this.isLoading = false;
          })
        },
        clearResourceCenterData(){
            this.$store.dispatch("ResourceCenter/clearFormData").then(()=>{
              this.goToResourceCenterEdit();
            });
        },
        searchInput(val){
          this.search = val;
        },
      },
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/variables.scss";
  .branch-data {
    background-color: $background-theme;
    margin: $margin-search;
  }
</style>
